export async function getBuildId(): Promise<string | null> {
  // 1) Preferred: Cloudflare Pages injects commit SHA at build time (no per-release changes needed)
  const envSha = import.meta.env.VITE_BUILD_SHA;
  if (typeof envSha === 'string' && envSha.trim().length > 0) {
    return envSha.trim();
  }

  // 2) Fallback: derive from Vite's hashed asset in index.html (no localStorage cache -
  //    cached values become stale after new deploys)
  try {
    const res = await fetch('/', { cache: 'no-store' });
    if (!res.ok) return null;
    const html = await res.text();
    // Match first script src like /assets/index-abc123.js
    const match = html.match(/src="\/assets\/[^"]+-([a-zA-Z0-9]+)\.js"/);
    const id = match?.[1] ?? null;
    if (id) return id;
  } catch {
    // ignore
  }
  return null;
}
































